import { useEffect } from "react";
import Icon from "../Icon";

// Tarjetas superpuestas de incidencia nueva, abajo a la derecha.
//
// Van en su propia pila y no por showToast: los toasts duran tres segundos y
// desaparecen, y un ticket que entra mientras no estás mirando la pantalla se
// perdería. Estas aguantan y se cierran una a una.

const SEGUNDOS = 15000;

function Aviso({ aviso, onAbrir, onCerrar, indice }) {
  useEffect(() => {
    const id = setTimeout(() => onCerrar(aviso.id), SEGUNDOS);
    return () => clearTimeout(id);
  }, [aviso.id]); // eslint-disable-line

  return (
    <div className="fu"
      style={{
        background:"var(--surface)", border:"1px solid color-mix(in srgb, var(--red) 45%, transparent)",
        borderRadius:11, boxShadow:"var(--shadow-lg)", padding:"11px 13px", width:"100%",
        display:"flex", flexDirection:"column", gap:5, cursor:"pointer",
        animationDelay:`${indice * 60}ms`,
      }}
      onClick={() => onAbrir(aviso)}>

      <div style={{ display:"flex", alignItems:"center", gap:7 }}>
        <Icon name="headset" size={12} color="var(--red-text)"/>
        <span style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:".07em",
                       color:"var(--red-text)" }}>
          Incidencia nueva
        </span>
        <span style={{ fontSize:10, fontFamily:"var(--mono)", color:"var(--text3)", marginLeft:"auto" }}>
          {aviso.numero}
        </span>
        <button aria-label="Descartar aviso" className="btn" onClick={e => { e.stopPropagation(); onCerrar(aviso.id); }}
          style={{minWidth:24,minHeight:24,alignItems:"center",justifyContent:"center",display:"inline-flex", padding:2, border:"none", background:"transparent", cursor:"pointer", lineHeight:0 }}>
          <Icon name="x" size={13} color="var(--text3)"/>
        </button>
      </div>

      <div style={{ fontSize:12.5, fontWeight:600, color:"var(--text)", lineHeight:1.35,
                    display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical", overflow:"hidden" }}>
        {aviso.titulo}
      </div>

      <div style={{ fontSize:10.5, color:"var(--text3)", display:"flex", gap:6, flexWrap:"wrap" }}>
        {aviso.contacto && <span>{aviso.contacto.nombre}</span>}
        {aviso.equipo   && <span>· {aviso.equipo.nombre}</span>}
      </div>
    </div>
  );
}

export default function AvisosTickets({ avisos, onAbrir, onCerrar }) {
  if (!avisos.length) return null;

  return (
    <div style={{ position:"fixed", right:18, bottom:18, zIndex:200,
                  width:"min(300px, calc(100vw - 36px))",
                  display:"flex", flexDirection:"column", gap:8, alignItems:"stretch" }}>
      {avisos.map((a, i) => (
        <Aviso key={a.id} aviso={a} indice={i} onAbrir={onAbrir} onCerrar={onCerrar}/>
      ))}
    </div>
  );
}
